import CpuOpponent from '../CpuOpponent';

export class Player {
    game = null
    playerObj = null
    id = null
    user_id = null
    name = ""
    score = 0
    sets = 0
    legs = 0
    throw = 0
    singlescores = []
    guest = false
    cpu = false
    cpu_time = null

    constructor(game, playerObj, cpudata, guest_start_id, cpu_start_id) {
        this.game = game;
        this.playerObj = playerObj;

        if (this.playerObj.type == "guest") {
            this.guest = true;
            this.name = this.playerObj.guestname ? this.playerObj.guestname : "Gast";
            this.id = guest_start_id;
            this.user_id = window.player.user_id;

            this.guest_start_id += 1;
        }

        if (this.playerObj.type == "computer") {
            this.cpu = true;
            this.cpu_time = cpudata.cpu_time;
            this.id = cpu_start_id;
            this.user_id = window.player.user_id;
            this.computer_level = this.playerObj.level;
            this.name = "CPU LVL " + this.playerObj.level;
            this.brain = new CpuOpponent(this.id, cpudata.start, this.computer_level, game.id, cpudata.cpu_time);
        }

        if (this.playerObj.type == "user") {
            this.name = this.playerObj.player.name;
            this.id = this.playerObj.player.id;
            this.user_id = this.playerObj.player.user_id;
        }
    }
}

export class Players {
    players = []
    active_player = null
    guest_start_id = 125
    cpu_start_id = 105

    addPlayer(game, playerObj, cpudata) {
        this.players.push(new Player(game,  playerObj, cpudata, this.guest_start_id, this.cpu_start_id));
        if (this.players[this.players.length-1].cpu) this.cpu_start_id += 1;
        if (this.players[this.players.length-1].guest) this.guest_start_id += 1;
        //first player was added, set as active_player for now
        if (this.players.length == 1) {
            this.active_player = this.players[0];
        }
    }

    activePlayer(id) {
        var returnPlayer = null;
        this.players.forEach(player => {
            if (id == player.id) {
                returnPlayer = player;
            }
        });
        this.active_player = returnPlayer;
        return returnPlayer;
    }

    //go to the next player and set as active
    loadNextPlayer() {
        var activePlayerIndex = -1;
        var returnPlayer;
        for (let idx = 0; idx < this.players.length; idx++) {
            const player = this.players[idx];
            if (player.id == this.active_player.id) {
                activePlayerIndex = idx;
            }
        }
        if (this.players.length > activePlayerIndex+1) {
            returnPlayer =  this.players[activePlayerIndex+1];
        } else {
            returnPlayer = this.players[0];
        }
        this.active_player = returnPlayer;
        return returnPlayer;
    }

    //sets the player with that id as current and loads the next player
    setPlayerAfter(id) {
        this.activePlayer(id);
        this.loadNextPlayer();
    }

    playerAfter(id) {
        var activePlayerIndex = -1;
        for (let idx = 0; idx < this.players.length; idx++) {
            const player = this.players[idx];
            if (player.id == id) {
                activePlayerIndex = idx;
            }
        }
        if (this.players.length > activePlayerIndex+1) {
            return this.players[activePlayerIndex+1];
        } else {
            return this.players[0];
        }
    }
}
